import formatDate from 'helpers/formatDate';
import pluralize from 'helpers/pluralize';
import formatNumber from 'helpers/formatNumber';

import { metadataProps } from '../metadataPropTypes';
import shouldRenderValue from 'helpers/shouldRenderValue';
import { Meta } from '../Metadata.style';

/**
 * This component shows meta data of a project.
 */
function ProjectMetadata({
  primaryArtist,
  releaseDate,
  trackCount,
  releaseCount,
  displayName,
  topic,
  isTrackCountDisplayed = true,
}) {
  return (
    <Meta>
      {topic && topic.includes('social')
        ? shouldRenderValue(displayName) && <span>{displayName}</span>
        : shouldRenderValue(primaryArtist) && (
            <span>{`by ${primaryArtist}`}</span>
          )}
      {shouldRenderValue(trackCount) && isTrackCountDisplayed && (
        <span>{`${formatNumber(trackCount)} ${pluralize(
          'track',
          trackCount
        )}`}</span>
      )}
      {shouldRenderValue(releaseCount) && (
        <span>{`${formatNumber(releaseCount)} ${pluralize(
          'release',
          releaseCount
        )}`}</span>
      )}
      {shouldRenderValue(releaseDate) && (
        <span>{`${formatDate(releaseDate, 'day-short')}`}</span>
      )}
    </Meta>
  );
}

ProjectMetadata.propTypes = {
  ...metadataProps,
};

export default ProjectMetadata;
